/* VENORA shipping protection.
 * - On by default whenever the customer sees the cart (drawer or cart page); the customer can turn it off.
 * - The choice is stored on the cart as a hidden attribute, so it is never re-added after opting out.
 * - Removed automatically when no other item is left in the cart (checked after every cart change).
 * - Never added on direct "buy now" paths, because the customer would not see it before checkout.
 */
(function () {
  if (window.__venoraShippingProtection) return;
  window.__venoraShippingProtection = true;

  var config = window.venoraShippingProtection || {};
  var variantId = Number(config.variantId);
  if (!variantId) return;

  var ATTRIBUTE = '_venora_shipping_protection';
  var TIMEOUT = 8000;
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var SECTION_RENDER = /[?&](section_id|sections)=/;
  var nativeFetch = window.fetch.bind(window);
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  var chain = Promise.resolve();
  var pending = 0;
  var mutationSeq = 0;
  var refreshGeneration = 0;
  var resubmitting = false;

  function timedFetch(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, TIMEOUT);
    var opts = Object.assign({}, options || {}, { signal: controller.signal });
    return nativeFetch(url, opts).finally(function () {
      clearTimeout(timer);
    });
  }

  function withTimeout(promise) {
    var timer;
    return Promise.race([
      promise,
      new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
          reject(new Error('timeout'));
        }, TIMEOUT);
      })
    ]).finally(function () {
      clearTimeout(timer);
    });
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function cartVisible() {
    return isCartPage() || !!document.querySelector('cart-drawer.active');
  }

  function postJSON(path, body) {
    return timedFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      mutationSeq += 1;
      return response.json();
    });
  }

  function getCart() {
    return timedFetch(root + '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(
      function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      }
    );
  }

  // No JSON Accept header here: on product URLs Shopify would answer with the product JSON instead of the sections.
  function fetchSections(keys) {
    var url = window.location.pathname + '?sections=' + encodeURIComponent(keys.join(','));
    return timedFetch(url, { cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('Section refresh failed');
      return response.json();
    });
  }

  function protectionLines(cart) {
    return cart.items.filter(function (item) {
      return Number(item.variant_id) === variantId;
    });
  }

  function hasProtection(cart) {
    return protectionLines(cart).length > 0;
  }

  // Brings the cart in line with the rules. Resolves true when the cart was changed.
  function reconcile(allowAdd) {
    return getCart().then(function (cart) {
      var lines = protectionLines(cart);
      var quantity = lines.reduce(function (total, line) {
        return total + line.quantity;
      }, 0);
      var others = cart.items.length - lines.length;
      var declined = (cart.attributes || {})[ATTRIBUTE] === 'declined';
      var updates = {};

      if (others === 0 || declined) {
        if (!lines.length) return false;
        lines.forEach(function (line) {
          updates[line.key] = 0;
        });
        return postJSON('/cart/update.js', { updates: updates }).then(function () {
          return true;
        });
      }
      if (quantity === 0) {
        if (!allowAdd) return false;
        return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] }).then(function () {
          return true;
        });
      }
      if (quantity > 1 || lines.length > 1) {
        lines.forEach(function (line, index) {
          updates[line.key] = index === 0 ? 1 : 0;
        });
        return postJSON('/cart/update.js', { updates: updates }).then(function () {
          return true;
        });
      }
      return false;
    });
  }

  function queue(task) {
    pending += 1;
    var run = chain.then(task, task);
    chain = run.catch(function () {});
    return run.finally(function () {
      pending -= 1;
    });
  }

  function lockItems(locked) {
    ['CartDrawer-CartItems', 'main-cart-items'].forEach(function (id) {
      var element = document.getElementById(id);
      if (element) element.classList.toggle('cart__items--disabled', locked);
    });
  }

  function refreshUI() {
    // Keep checkout blocked through a cart-page reload as well as drawer refreshes.
    pending += 1;
    if (isCartPage()) {
      window.location.reload();
      return new Promise(function () {});
    }
    var generation = ++refreshGeneration;
    return Promise.all([fetchSections(['cart-drawer', 'cart-icon-bubble']), getCart()])
      .then(function (results) {
        if (generation !== refreshGeneration) return;
        var sections = results[0];
        var cart = results[1];
        var drawer = document.querySelector('cart-drawer');
        var current = document.getElementById('CartDrawer');
        if (sections['cart-drawer'] && current) {
          var drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = drawerDoc.getElementById('CartDrawer');
          if (fresh) {
            current.innerHTML = fresh.innerHTML;
            var overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay && drawer && typeof drawer.close === 'function') {
              overlay.addEventListener('click', drawer.close.bind(drawer));
            }
          }
        }
        if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
        var bubble = document.getElementById('cart-icon-bubble');
        if (sections['cart-icon-bubble'] && bubble) {
          var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var bubbleSource = bubbleDoc.querySelector('.shopify-section');
          if (bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
        }
      })
      .finally(function () {
        pending -= 1;
      });
  }

  function reconcileAndRefresh(allowAdd) {
    lockItems(true);
    return queue(function () {
      return reconcile(allowAdd);
    })
      .then(function (changed) {
        if (changed) return refreshUI();
      })
      .catch(function () {})
      .finally(function () {
        lockItems(false);
      });
  }

  function idle() {
    return new Promise(function (resolve) {
      var started = Date.now();
      (function check() {
        if (pending === 0 || Date.now() - started > TIMEOUT * 2) return resolve();
        setTimeout(check, 50);
      })();
    });
  }

  function cartResponse(response, data) {
    return new Response(JSON.stringify(data), {
      status: response.status,
      statusText: response.statusText,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function markSectionsStale(response) {
    return response.clone().json().then(function (data) {
      if (!data || !data.sections || typeof data.sections !== 'object') return response;
      // The optimized PDP refreshes this HTML without adding again. Keep the
      // original section values for legacy theme consumers that do not read the flag.
      data._venoraSectionsStale = true;
      return cartResponse(response, data);
    }).catch(function () {
      return response;
    });
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var seqAtStart = mutationSeq;
    var request = nativeFetch(input, init);

    // Theme section renders that started before a protection change re-render after it.
    if (method === 'GET' && SECTION_RENDER.test(url) && !CART_MUTATION.test(url)) {
      return request.then(function (response) {
        if (seqAtStart === mutationSeq) return response;
        return nativeFetch(input, init).catch(function () {
          return response;
        });
      });
    }

    if (!CART_MUTATION.test(url)) return request;

    return request.then(function (response) {
      if (!response.ok) return response;
      var allowAdd = cartVisible();
      return withTimeout(
        queue(function () {
          return reconcile(allowAdd);
        })
      )
        .then(function (changed) {
          if (!changed && seqAtStart === mutationSeq) return response;
          return response
            .clone()
            .json()
            .then(function (data) {
              if (!data || typeof data !== 'object') return response;
              var keys = data.sections && typeof data.sections === 'object' ? Object.keys(data.sections) : [];
              // /cart/add returns only added items, so a full-cart read here is unused.
              // Full cart responses still need it to keep totals and quantities fresh.
              var fullCartResponse = Array.isArray(data.items) && typeof data.item_count === 'number';
              return Promise.all([
                keys.length ? fetchSections(keys) : Promise.resolve({}),
                fullCartResponse ? getCart() : Promise.resolve(null)
              ]).then(function (results) {
                var freshSections = results[0];
                var cart = results[1];
                keys.forEach(function (key) {
                  if (freshSections && typeof freshSections[key] === 'string') {
                    data.sections[key] = freshSections[key];
                  } else {
                    // Tell the optimized PDP to retry rendering, while preserving
                    // the legacy section response contract for other cart consumers.
                    data._venoraSectionsStale = true;
                  }
                });
                if (fullCartResponse) {
                  var sections = data.sections;
                  Object.keys(cart).forEach(function (field) {
                    data[field] = cart[field];
                  });
                  if (sections) data.sections = sections;
                }
                return cartResponse(response, data);
              });
            });
        })
        .catch(function () {
          // Reconciliation/refresh can fail after the cart has already changed.
          // The optimized PDP detects this marker and fetches settled HTML instead
          // of displaying the pre-protection totals from the successful add response.
          return markSectionsStale(response);
        });
    });
  };

  function syncCardFromCart(card, toggle) {
    return getCart()
      .then(function (cart) {
        var on = hasProtection(cart);
        card.classList.toggle('is-added', on);
        toggle.setAttribute('aria-checked', String(on));
        card.classList.remove('is-busy');
      })
      .catch(function () {
        window.location.reload();
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-venora-sp-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var card = toggle.closest('[data-venora-sp]');
    if (!card || card.classList.contains('is-busy')) return;
    var turnOn = toggle.getAttribute('aria-checked') !== 'true';
    card.classList.add('is-busy');
    card.classList.toggle('is-added', turnOn);
    toggle.setAttribute('aria-checked', String(turnOn));
    lockItems(true);
    queue(function () {
      return postJSON('/cart/update.js', { attributes: { [ATTRIBUTE]: turnOn ? '' : 'declined' } }).then(function () {
        return reconcile(true);
      });
    })
      .then(
        function () {
          return refreshUI().catch(function () {
            return syncCardFromCart(card, toggle);
          });
        },
        function () {
          return syncCardFromCart(card, toggle);
        }
      )
      .finally(function () {
        lockItems(false);
      });
  });

  // Lasso listens before form submission. Catch early activation at window capture
  // so it cannot navigate away while a protection choice is still being saved.
  function guardPendingCheckout(event) {
    if (pending === 0 && !document.querySelector('[data-venora-sp].is-busy')) return;
    var target = event.target;
    var checkout = false;
    if (event.type === 'submit') {
      checkout = target && (target.id === 'cart' || target.id === 'CartDrawer-Form') &&
        event.submitter && event.submitter.name === 'checkout';
    } else if (target && typeof target.closest === 'function') {
      checkout = target.closest(
        'button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, #checkout, #vopCustomBuy, [data-lasso-checkout], a[href*="/checkout"]'
      );
    }
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  ['pointerdown', 'mousedown', 'touchstart', 'click', 'submit'].forEach(function (type) {
    window.addEventListener(type, guardPendingCheckout, { capture: true, passive: false });
  });

  // Checkout waits for any protection change that is still in flight, so the order matches the card.
  document.addEventListener(
    'submit',
    function (event) {
      if (resubmitting || pending === 0) return;
      var form = event.target;
      var submitter = event.submitter;
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
      if (!submitter || submitter.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      idle().then(function () {
        resubmitting = true;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
        else submitter.click();
        setTimeout(function () {
          resubmitting = false;
        }, 1000);
      });
    },
    true
  );

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      if (open && !wasOpen) reconcileAndRefresh(true);
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    watchDrawer();
    if (cartVisible()) reconcileAndRefresh(true);
    else if (config.orphan) reconcileAndRefresh(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

